import { render, staticRenderFns } from "./ProcedureReportTable.vue?vue&type=template&id=70bde19c&"
import script from "./ProcedureReportTable.vue?vue&type=script&lang=js&"
export * from "./ProcedureReportTable.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureReportTable.vue?vue&type=style&index=0&id=70bde19c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports